import * as React from 'react';
import { useSelector } from "react-redux";
import { Redirect, Route } from 'react-router-dom'
import { LOGIN } from './routes';
import ErrorBoundary from '../components/ErrorBoundaries/ErrorBoundary';

const SecureRoute = ({ component: Component, ...rest }) => {

    const auth = useSelector(state => state.firebase.auth);
    let loggedIn = ('uid' in auth) ? true : false;
    let isLoaded = (auth.isLoaded);

    if (!isLoaded) return null;

    return (
        <Route
            {...rest}
            render={props =>
                loggedIn ? (
                    <ErrorBoundary>
                        <Component {...props} />
                    </ErrorBoundary>
                ) : (
                        <Redirect to={LOGIN} />
                    )
            }
        />
    )
}

export default SecureRoute;